export const Login_Schema = {
  fields: {
    findPwForm: {
      userId: { initial: '', label: '사용자ID' },
      userNm: { initial: '', label: '성명' },
      userTel: { initial: '', label: '전화번호' },
      identityConfirm: { initial: false, label: '본인인증여부' },
      identityErrMsg: { initial: '', label: '본인인증메시지' },
      tempPassword: { initial: '', label: '임시비밀번호' },
      issueMessage: { initial: '', label: '발급메시지' },
      successful: { initial: false, label: '발급성공여부' },
    },
  },
};
